import { VELTHUIS_CAMPAIGN_PREFIX } from '@/utils/common.ts'

const bmiCategories = ['BORST', 'LICHAAM', 'GEZICHT']
const eyelidsCategory = 'GEZICHT'
const eyelidsTreatments = ['CON_PC_G_OOL', 'CON_PC_G_BOL']

const parseCampaignCategory = (category: string) => {
  return category.replace(VELTHUIS_CAMPAIGN_PREFIX, '')
}

const isEyelidTreatment = (treatment: string, category: string) => {
  return (
    parseCampaignCategory(category) === eyelidsCategory &&
    eyelidsTreatments.includes(treatment)
  )
}

export const showBMIForCategory = (category: string) => {
  return bmiCategories.includes(parseCampaignCategory(category))
}

export const getBMIThreshold = (treatment: string, category: string) => {
  if (isEyelidTreatment(treatment, category)) {
    return 35
  }
  if (showBMIForCategory(category)) {
    return 30
  }
  return null
}

export const checkBMICompliance = (
  treatment: string,
  category: string,
  bmi: number,
) => {
  const threshold = getBMIThreshold(treatment, category)

  if (threshold === null) {
    return true
  }

  return bmi <= threshold
}
